import { Component, OnInit, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { ModularSearchField_ext } from '../models/ModularSearchField_ext';
import { Log_ext } from '../models/log-ext';
import { StarbaseSearchComponent } from 'starbase-launcher';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-log-search',
  templateUrl: './log-search.component.html',
  styleUrls: ['./log-search.component.css']
})
export class LogSearchComponent extends StarbaseSearchComponent<Log_ext> implements OnInit, AfterViewInit, OnDestroy {
  @Input() tooltipDelay = 500;

  protected modularSearchFields: ModularSearchField_ext<Log_ext>[] = [
    {
      fieldName: 'user',
      displayName: 'User',
      entityProps: ['User'],
      default: true,
      enabled: true,
      filterClause: (a: Log_ext, searchChars: string) => a.user && a.user.toLowerCase().includes(searchChars)
    },
    {
      fieldName: 'message',
      displayName: 'Message',
      entityProps: ['Message'],
      default: true,
      enabled: true,
      filterClause: (a: Log_ext, searchChars: string) => a.message && a.message.toLowerCase().includes(searchChars)
    },
    {
      fieldName: 'guid',
      displayName: 'Guid',
      entityProps: ['EntityGuid'],
      default: true,
      enabled: true,
      filterClause: (a: Log_ext, searchChars: string) => a.entityGuid && a.entityGuid.toLowerCase().includes(searchChars)
    }
  ];

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  public getEnabledFilterExplicitProperties(): string[] {
    return this.modularSearchFields.filter(a => a.enabled && a.entityProps).map(b => b.entityProps.toString()).toString().split(',');
  }

  protected runSearch(searchChars: string): Observable<Log_ext[]> {
    return of([]); // search is handled by table editor this is a dummy method.
  }

  setTextToDisplay(m: Log_ext): string {
    throw new Error('Method not implemented');
  }

}
